import axios from 'axios';

let appKey = '41ceaff819644d68861705eb82a40f7a';
let secretId = 'b1ffdc93d57713e0d975c8f8585c8e4b';
let applyContainer = null;
let applyForm = null;
let nameContainer = null;
let companyContainer = null;
let telContainer = null;
let emailContainer = null;
let vcodeContainer = null;
let errorMsg = null;
let successMsg = null;
let submitBtn = null;
let isVCode = false;
let basePath = '//debug.talkingdata.com/api/v1';
let emialBasePath = '//debug.talkingdata.com/api/v1/commitForm';
let issubmiting = false;
let timeout = null;
let submitType = null;
let submitTitle = null;
let id = null;
let applyFormBound = false;
let leadSourceFromClick = null;
let leadTrackingBound = false;

const PAGE_PRODUCT_IDS = {
  '/': 1,
  '/index.jsp': 1,
  '/agi-dataset.jsp': 20,
  '/data-annotation.jsp': 21,
  '/cineon.jsp': 22,
  '/clawshell.jsp': 23,
  '/use-cases.jsp': 24,
  '/data-service.jsp': 25,
  '/ai-apps.jsp': 26,
  '/analytics-marketing.jsp': 27,
  '/smartdp.jsp': 28,
};

function bindApplyFormElements() {
  applyContainer = document.querySelector('.apply-container');
  if (!applyContainer) {
    return false;
  }

  applyForm = applyContainer.querySelector('.user-message');
  if (!applyForm) {
    return false;
  }

  nameContainer = applyForm.querySelector('span[name="name"]');
  companyContainer = applyForm.querySelector('span[name="company"]');
  telContainer = applyForm.querySelector('span[name="tel"]');
  emailContainer = applyForm.querySelector('span[name="email"]');
  vcodeContainer = applyForm.querySelector('span[name="vcode"]');
  errorMsg = applyForm.querySelector('.error-msg');
  successMsg = applyForm.querySelector('.success-msg');
  submitBtn = applyForm.querySelector('button[name=submit]');

  return !!(nameContainer && companyContainer && telContainer && emailContainer && vcodeContainer && submitBtn);
}

if (location.hostname == 'www.talkingdata.com') {
  emialBasePath = '//www.talkingdata.com/api/v1/commitForm';
  basePath = '//www.talkingdata.com/api/v1';
}
// http://www.talkingdata.com/api/v1/commitForm
let paramobj = {
  device: {
    deviceId: {
      tid: '3b670cdba598f84cde6eed9a0944cbc44',
      imeis: [
        '355136056556064',
      ],
      wifiMacs: [
        '98:D6:F7:8F:D0:C6',
      ],
      androidId: 'ab27a3201e11f786',
      serialNo: '01dcb33a15c82cd8',
    },
  },
  app: {
    name: 'BaseDataCollector',
    globalId: 'com.jianlu.basedatacollector',
    versionName: '1.2',
    versionCode: 4,
    installTime: 1432120073823,
    updateTime: 1432120364892,
    appKey: {
      service: 'sms',
      appKey,
    },
  },
  action: {
    domain: 'sms',
    name: 'apply',
    data: {
      mobile: '18612967208',
      countryCode: '86',
      secretId,
      acctName: '',
    },
  },
};
function submit(e) {
  fnSubmit(submitBtn);
}
function getVcode(e) {
  if (/^1(\d{10})/gi.test(telContainer.querySelector('input').value.trim()) == false) {
    showMessage(telContainer.querySelector('em'));
    return false;
  }
  let i = 60;
  if (isVCode === true) {
    return;
  }
  isVCode = true;
  paramobj.device.deviceId.tid = uuid(32, 36);
  paramobj.action.data.mobile = telContainer.querySelector('input').value.trim();
  paramobj.action.data.acctName = `${telContainer.querySelector('input').value.trim() }@td.com`;
  reqAjax(`${basePath }/applyCheck`, paramobj, (data) => {
    if (data.errorMessage == 'OK') {
      // TD_MC_lis.eq(4).find('label').show();
      // 倒计时
      timeout = setInterval(() => {
        i--;
        vcodeContainer.querySelector('i').innerHTML = `${i }秒`;
        if (i === 0) {
          clearInterval(timeout);
          isVCode = false;
          vcodeContainer.querySelector('i').innerHTML = '点击获取验证码';
        }
      }, 1000);
    } else {
      clearInterval(timeout);
      isVCode = false;
      vcodeContainer.querySelector('i').innerHTML = '点击获取验证码';
      errorMsg.innerHTML = '验证码获取失败,请稍后再试.';
      showMessage(errorMsg);
    }
  }, 'post');
}
function fnSubmit(_thisbtn) {
  if (nameContainer.querySelector('input').value.trim() == '') {
    showMessage(nameContainer.querySelector('em'));
    return false;
  }
  if (/^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/gi.test(emailContainer.querySelector('input').value.trim()) == false) {
    showMessage(emailContainer.querySelector('em'));
    return false;
  }
  if (companyContainer.querySelector('input').value.trim() == '') {
    showMessage(companyContainer.querySelector('em'));
    return false;
  }
  if (/^1(\d{10})/gi.test(telContainer.querySelector('input').value.trim()) == false) {
    showMessage(telContainer.querySelector('em'));
    return false;
  }
  if (vcodeContainer.querySelector('input').value.trim() == '') {
    var wrong4 = vcodeContainer.querySelector('em');
    wrong4.innerHTML = '请填写验证码!';
    showMessage(wrong4);
    return false;
  }
  // 校验验证码
  if (/(\d{6})/gi.test(vcodeContainer.querySelector('input').value.trim()) == false) {
    var wrong4 = vcodeContainer.querySelector('em');
    wrong4.innerHTML = '您输入的验证码不正确!';
    showMessage(wrong4);
    return false;
  }
  // 重复提交
  _thisbtn.innerHTML = '提交中...';
  _thisbtn.style.backgroundColor = '#707c8d';
  if (issubmiting == true) {
    return;
  }
  issubmiting = true;
  paramobj.device.deviceId.tid = uuid(32, 36);
  paramobj.action.data.mobile = telContainer.querySelector('input').value.trim();
  paramobj.action.data.acctName = `${telContainer.querySelector('input').value.trim() }@td.com`;
  paramobj.action.data.securityCode = vcodeContainer.querySelector('input').value.trim();
  setTimeout(() => {
    reqAjax(`${basePath }/authorizedCheck`, paramobj, (data) => {
      if (data.errorMessage == '') {
        submitAjax();
      } else {
        if (errorMsg) {
          errorMsg.innerHTML = data.errorMessage;
          showMessage(errorMsg);
        }
        resetSubmitButton('提交');
      }
    }, 'post');
  }, 300);
}

function parseResponseData(data) {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (parseError) {
      return data;
    }
  }
  return data;
}

function resetSubmitButton(label) {
  if (submitBtn) {
    submitBtn.innerHTML = label || '提交';
    submitBtn.style.backgroundColor = null;
  }
  issubmiting = false;
}

function reqAjax(dataURL, param, callback, type) {
  type = type || 'GET';
  let promise;
  let requestConfig = {
    timeout: 5000,
    headers: {
      'content-type': 'application/json;charset=utf-8',
      PlainJson: 'hunibin',
    },
  };
  if (type == 'GET') {
    promise = axios.get(dataURL, Object.assign({ params: param }, requestConfig));
  } else {
    promise = axios.post(dataURL, param, requestConfig);
  }
  promise.then((res) => {
    let { status } = res;
    if (status == 200) {
      callback(parseResponseData(res.data));
    } else {
      if (errorMsg) {
        errorMsg.innerHTML = '请求失败,请与客服联系.';
        showMessage(errorMsg);
      }
      if (issubmiting) {
        resetSubmitButton('提交');
      }
    }
  })
    .catch(() => {
      if (errorMsg) {
        errorMsg.innerHTML = '请求失败,请与客服联系.';
        showMessage(errorMsg);
      }
      if (issubmiting) {
        resetSubmitButton('提交');
      }
    });
}
function normalizeText(value) {
  return (value || '').replace(/\s+/g, ' ').trim();
}

function resolvePageName() {
  let dataPage = document.body && document.body.getAttribute('data-lead-page');
  if (dataPage) {
    return normalizeText(dataPage);
  }
  let subnavLabel = document.querySelector('.ds-subnav__label');
  if (subnavLabel) {
    return normalizeText(subnavLabel.textContent);
  }
  if (submitTitle) {
    return normalizeText(submitTitle);
  }
  return 'TalkingData官网';
}

function resolveSectionLabel(fromElement) {
  if (!fromElement || !fromElement.closest) {
    return null;
  }
  let section = fromElement.closest('section');
  if (!section || section.id === 'contact') {
    return null;
  }
  if (section.classList.contains('ds-hero') || !section.id) {
    return null;
  }
  let dataSection = section.getAttribute('data-lead-section');
  if (dataSection) {
    return normalizeText(dataSection);
  }
  let subnavLink = document.querySelector('[data-ds-anchor="' + section.id + '"]');
  if (subnavLink) {
    return normalizeText(subnavLink.textContent);
  }
  let eyebrow = section.querySelector('.ds-section__eyebrow');
  if (eyebrow) {
    let eyebrowClone = eyebrow.cloneNode(true);
    let badges = eyebrowClone.querySelectorAll('.hub-badge, span');
    for (let badgeIndex = 0; badgeIndex < badges.length; badgeIndex++) {
      if (badges[badgeIndex].classList.contains('hub-badge')) {
        badges[badgeIndex].parentNode.removeChild(badges[badgeIndex]);
      }
    }
    let eyebrowText = normalizeText(eyebrowClone.textContent);
    if (eyebrowText) {
      return eyebrowText;
    }
  }
  return null;
}

function resolveLeadTitle() {
  let pageName = resolvePageName();
  if (leadSourceFromClick) {
    return leadSourceFromClick;
  }
  return pageName;
}

function resolveComeFrom() {
  let dataProductId = document.body && document.body.getAttribute('data-lead-product-id');
  if (dataProductId) {
    return dataProductId;
  }
  if (id !== null && id !== undefined && id !== '') {
    return id;
  }
  let pathname = window.location.pathname || '';
  let matchedId = PAGE_PRODUCT_IDS[pathname];
  if (matchedId) {
    return matchedId;
  }
  let pathKey;
  for (pathKey in PAGE_PRODUCT_IDS) {
    if (pathKey !== '/' && pathname.indexOf(pathKey) !== -1) {
      return PAGE_PRODUCT_IDS[pathKey];
    }
  }
  return 1;
}

function rememberLeadSourceFromElement(fromElement) {
  let pageName = resolvePageName();
  let sectionLabel = resolveSectionLabel(fromElement);
  leadSourceFromClick = sectionLabel ? (pageName + '-' + sectionLabel) : pageName;
}

function bindLeadSourceTracking() {
  if (leadTrackingBound) {
    return;
  }
  leadTrackingBound = true;
  document.addEventListener('click', function (event) {
    let target = event.target;
    if (!target || !target.closest) {
      return;
    }
    let leadLink = target.closest('a[href="#contact"], a[href$="#contact"]');
    if (!leadLink) {
      return;
    }
    // 跨页跳到其他页 #contact：记录目标页本身即可，由目标页初始化
    let hrefValue = leadLink.getAttribute('href') || '';
    if (hrefValue.indexOf('#contact') !== -1 && hrefValue !== '#contact' && hrefValue.charAt(0) !== '#') {
      return;
    }
    rememberLeadSourceFromElement(leadLink);
  }, true);
}

function submitAjax() {
  let param = {
    firstName: nameContainer.querySelector('input').value.trim(),
    company: companyContainer.querySelector('input').value.trim(),
    tel: telContainer.querySelector('input').value.trim(),
    email: emailContainer.querySelector('input').value.trim(),
    sendMailFlag: 1, // 1发送 0不发送
    type: submitType,
    url: window.location.pathname + window.location.hash,
    basePath,
    comeFrom: resolveComeFrom(),
    extend1: resolveLeadTitle(),
  };
  reqAjax(emialBasePath, param, (data) => {
    let responseCode = data && data.code;
    if (responseCode == 0 || responseCode === '0') {
      clearValue();
      leadSourceFromClick = null;
      showMessage(successMsg);
      return;
    }
    if (errorMsg) {
      errorMsg.innerHTML = (data && data.message) || '提交失败,请稍后再试.';
      showMessage(errorMsg);
    }
    resetSubmitButton('提交');
  }, 'post');
}
// 清空操作
function clearValue() {
  nameContainer.querySelector('input').value = '';
  companyContainer.querySelector('input').value = '';
  telContainer.querySelector('input').value = '';
  emailContainer.querySelector('input').value = '';
  vcodeContainer.querySelector('input').value = '';
  resetSubmitButton('提交');
  // 验证码重置
  clearInterval(timeout);
  isVCode = false;
  if (vcodeContainer && vcodeContainer.querySelector('i')) {
    vcodeContainer.querySelector('i').innerHTML = '点击获取验证码';
  }
}

function showMessage(_thisdom) {
  if (!_thisdom) {
    return;
  }
  _thisdom.style.display = 'inline-block';
  setTimeout(() => {
    _thisdom.style.display = 'none';
  }, 3000);
}

// 生成uuid
function uuid(len, radix) {
  let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  let uuid = []; let
    i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data. At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
}

// eslint-disable-next-line import/prefer-default-export
export function contractInit(type, title, val) {
  submitType = type || 'in';
  submitTitle = title || resolvePageName();
  id = val !== undefined && val !== null && val !== '' ? val : resolveComeFrom();

  bindLeadSourceTracking();

  if (!bindApplyFormElements() || applyFormBound) {
    return;
  }

  applyFormBound = true;
  vcodeContainer.querySelector('i').addEventListener('click', getVcode);
  submitBtn.addEventListener('click', submit);
}
